
import { motion } from "framer-motion";
import { Building } from "lucide-react";
import SidebarGalleryPage from "../Main/Sidebargallery";
import cb_banner from "../../assets/Feedback/cb_banner.jpg";

export default function SpecialSchemes() {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto p-4 md:p-6 flex flex-col lg:flex-row gap-8">
        {/* Left Column - Special Schemes */}
        <motion.div
          className="lg:w-2/3"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="space-y-6">
            {/* Section Header */}
            <div className="">
              {/* Image Section */}
              <motion.img
                src={cb_banner}
                alt="Special Schemes"
                className="w-full shadow-md p-2 border-4 border-teal-500  rounded-lg mb-10"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1 }}
              />
              <div className="border-4 border-teal-500 rounded-lg p-2">
                  <h2 className="text-xl font-bold mb-4 flex items-center gap-2 bg-[#00BFA5] text-white rounded-sm w-full p-4">
                    <Building className="w-6 h-6" />
                    Special Schemes
                  </h2>
                  {/* Updated Text */}
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="leading-relaxed p-2"
                  >
                    Employment-oriented short-term training programs are being run
                    for reserved category students. The institute provides
                    employment and self-employment-oriented training in fields like
                    tailoring, data entry operation, fashion design, gents and
                    women’s wear making, and more. Special campus seminars on
                    various topics are also organized to enhance opportunities for
                    students.
                  </motion.p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Right Column - Gallery */}
        <SidebarGalleryPage />
      </div>
    </div>
  );
}
